module.exports = __webpack_public_path__ + "static/media/project-collaborator.5b3fdce2.svg";